module.exports = __webpack_public_path__ + "static/img/14000013.f8a20dc1.png";